// extracted by mini-css-extract-plugin
module.exports = {"root":"EffettiSection_root__UxSFY","slider":"EffettiSection_slider__ZdPhB","rotation":"EffettiSection_rotation__c8tvM"};